import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { getImgixSrc } from '@utils/images';

import { EVENT_SUBSCRIBE_MODULE_OFFER_CODES } from './constants';
import { EventSubscribeModuleProps } from './interfaces';

const DEVICES_IMAGE_SRC = getImgixSrc({
  path: 'events/subscribe-module-devices.png',
  isEnvDependent: false,
});

const EventSubscribeModule = ({ isSubscriber }: EventSubscribeModuleProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.EventsShowPageSubscribeModule,
  });

  if (isSubscriber) return null;

  return (
    <aside
      className="mt-48 bg-grayscale-beige/50 py-64 xl:pt-[27px]"
      data-test="event-subscribe-module"
    >
      <div className="m-auto flex max-w-[1290px] flex-col items-center gap-16 sm:gap-32 xl:flex-row-reverse xl:justify-center xl:gap-0">
        <div className="relative z-10 w-full shrink-0 px-16 text-center sm:max-w-[550px] sm:px-0 xl:text-left">
          <h2 className="m-0 text-balance font-suisse-works text-headline-sm text-primary-black sm:text-headline-md">
            Subscribe to The Information
          </h2>
          <p className="mb-0 mt-4 text-pretty font-suisse-neue text-body-lg font-normal text-primary-black sm:text-subheadline-lg">
            Gain early bird discount to all Events with your subscription.
          </p>
          <PrimaryButton
            as="link"
            href={subscribe_path({ offer: EVENT_SUBSCRIBE_MODULE_OFFER_CODES })}
            className="mt-24 !w-full"
            onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.Subscribe }))}
          >
            Subscribe
          </PrimaryButton>
        </div>
        <LazyImgixImage
          alt="The Information on a laptop and phone"
          src={DEVICES_IMAGE_SRC}
          sizes="(max-width: 767px) 100vw, 774px"
          className="w-full max-w-[774px]"
          wrapperClassName="!flex w-full justify-center xl:-mr-[34px]"
        />
      </div>
    </aside>
  );
};

export default EventSubscribeModule;
